<!--  -->
<template>
  <div>
    <!-- 阅文 -->
    <div class="optionbox">
      <div class="optiontext">渠道名称：</div>
      <el-input v-model="name" style="width:300px" placeholder="请输入内容" />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广成本：</div>
      <el-input v-model="money" style="width:300px" placeholder="请输入内容" type="number" @blur="activegivemoney" />
    </div>
    <div style="margin:0px 0px 20px 100px">
      <i class="el-icon-info" style="margin-right:5px" />建议选择主动关注，选择强制关注可能被封号，风险自行承担
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广链接类型：</div>
      <el-radio-group v-model="tuiguangradio">
        <el-radio :label="1">外部</el-radio>
        <el-radio :label="2">内部</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">强关设置：</div>
      <el-radio-group v-model="strongpassradio">
        <el-radio :label="2">主动关注</el-radio>
        <el-radio :label="3">强制关注</el-radio>
        <el-radio :label="1">不设置强关</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">强关章节序号：</div>
      <!-- <el-input v-model="forcechapter" style="width:300px" placeholder="请输入内容" type="number" @blur="forcechapterblur" /> -->
      <el-select v-model="forcechapter" style="width:300px" placeholder="请选择强关章节序号">
        <el-option
          v-for="item in qiangoptions"
          :key="item.chapter_idx"
          :label="item.chapter_name"
          :value="item.chapter_idx"
        />
      </el-select>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">底部关注引导：</div>

      <div style="position: relative; display: inline-block;">
        <el-switch
          v-model="bottomidr"
          :width="60"
          active-color="#13ce66"
          inactive-color="rgb(191,191,191)"
          :active-value="1"
          :inactive-value="0"
        />
        <div
          v-if="bottomidr === 1"
          style="color: #fff;position: absolute;top: 2px;left: 7px;"
        >启用</div>
        <div
          v-else
          style="color: #fff;position: absolute;top: 2px;right: 7px;"
        >禁用</div>
      </div>
    </div>
    <div class="loltext">开启阅读页底部关注引导二维码</div>
    <el-button type="primary" @click="sumbit">确定</el-button>
    <!-- {{ objquery }} -->
  </div>
</template>

<script>
import { bookPlatformcreate, createtemplate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      name: '',
      money: '',
      strongpassradio: 2,
      forcechapter: '',
      bottomidr: 1,
      tuiguangradio: 1,
      qiangoptions: []
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        console.log('111', newValue)
        this.objquery = newValue
        this.name = newValue.bookname + '-' + newValue.chaptername
        this.menuList(newValue.bookids, newValue.platformvalue)
        this.forcechapter = ''
      },
      deep: true
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    activegivemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.money < 0 && this.money != '') {
        this.money = 1
      }
    },
    // 获取章节
    menuList(bookid, platformvalue) {
      createtemplate({
        // page: this.page,
        // page_size: this.pageSize,
        novel_id: bookid,
        platform_id: platformvalue
      }).then(res => {
        console.log('res', res)
        this.qiangoptions = res.data.chapter
      })
    },
    async sumbit() {
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入渠道名称')
        return
      }
      if (this.money === '') {
        this.$message.error('请输入推广成本')
        return
      }
      if (this.forcechapter === '') {
        this.$message.error('请选择强关章节序号')
        return
      }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          cbid: this.objquery.bookid,
          ccid: this.objquery.chapterid,
          name: this.name,
          channel_type: this.tuiguangradio,
          force_style: this.strongpassradio,
          bottom_QR: this.bottomidr,
          force_chapter: this.forcechapter,
          cost: this.money,
          chapter_name: this.objquery.chaptername
        }
      })
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
    },
    forcechapterblur() {
      // eslint-disable-next-line eqeqeq
      if (this.forcechapter <= 0 && this.forcechapter != '') {
        this.forcechapter = 1
      }
      // 判断不能输入小数点
      const str = '' + this.forcechapter
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.forcechapter = 1
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}
.loltext{
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
